var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedRadioButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5660",
    "data-name": "Group 5660",
    transform: "translate(-24 -596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_289",
    "data-name": "Ellipse 289",
    transform: "translate(24 596)",
    fill: "#fff",
    stroke: "#ed2024",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_324",
    "data-name": "Ellipse 324",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(27 599)",
    fill: "#ed2024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedRadioButton);
export default __webpack_public_path__ + "static/media/checkedRadioButton.5d55d8a5ec40edeb857a8802ca1b5364.svg";
export { ForwardRef as ReactComponent };